module.exports = __webpack_public_path__ + "static/img/5.18d11d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/eng/5.png
// module id = Toyb
// module chunks = 0